module.exports = __webpack_public_path__ + "static/img/qnjyz.120ac70e.jpg";